<template>
  <b-form-group
    id="fieldset-1"
    label="メモ"
  >
    <b-form-textarea
      v-model="model"
      placeholder="15時帰社予定"
      rows="3"
      max-rows="6"
    >
    </b-form-textarea>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'user/seatingStatus',
      attribute: 'memo'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  }
}
</script>
